import _ from 'underscore';

const buildQuery = (filters) => {
  const query = {
    bool: {
      must: _(filters.query).map((value, key) => {
        let operator = 'match';
        if (_.isArray(value)) {
          operator = 'terms';
          if (key === "market")
            value = value.map(v => v.toLowerCase());
        }

        return {
          [operator]: {
            [key]: value
          }
        }
      })
    }
  };
  if (filters.deny) {
    query.bool.must_not = _(filters.deny).map((value, key) => {
      const operator = _.isArray(value) ? 'terms' : 'match';
      return {
        [operator]: {
          [key]: value
        }
      }
    });
  };
  return query;
};

const periodFilter = (period) => {
  return {
    range: {
      deliverByDate: {
        gte: period.start,
        lte: period.end
      }
    }
  }
};


const aggregateWithTimeRangeFilter = (filter, aggs) => {
  return aggs;
};

const aggregateInPeriods = (periods, aggs) => {
  var periodList = periods.length ? periods : [periods];
  var periodAggregations = {};
  _(periodList).map((period) => {
    _(aggs).map((agg, name) => {
      periodAggregations[name + '_' + period.name] = {
        filter: periodFilter(period),
        aggs: {
          [name]: agg.aggregation
        }
      };
    });
  });
  return periodAggregations;
};

const aggregateInBucket = (bucket, aggs) => {
  var bucketedAggs = {};
  var bucketName = _.first(_.keys(bucket));
  var bucketAgg = bucket[bucketName];
  _(aggs).map((agg, name) => {
    bucketedAggs[name] = {}
    bucketedAggs[name][bucketName] = {}
    bucketedAggs[name][bucketName] = bucketAgg;
    bucketedAggs[name].aggs = agg
  });
  return bucketedAggs;
};

export default class ESRequest {
  constructor() {
    this.body = {};
    return this;
  }
  query(filters) {
    this.body.query = buildQuery(filters);
    console.log(this.body.query);
    return this;
  }
  aggregate(aggs) {
    this.body.aggs = aggs
    return this;
  }
  aggregateWithTimeRangeFilter(filter, aggs) {
    this.body.aggs = aggregateWithTimeRangeFilter(filter, aggs || this.body.aggs);
    return this;
  }
  aggregateInPeriods(periods, aggs) {
    this.body.aggs = aggregateInPeriods(periods, aggs || this.aggs.body);
    return this;
  }
  aggregateInBucket(bucket, aggs) {
    this.body.aggs = aggregateInBucket(bucket, aggs || this.body.aggs);
    return this;
  }
}
